import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@speedoc/design-assets/build/icons";
import SectionHeading from "./sectionHeading";
import SolutionsList from "./solutionsList";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BusinessSection = ({ content }) => {
  const { title, subtitle, image, linkUrl, linkText, list } = content;
  return (
    <div id="businessSection">
      <div className="sectionBody">
        <div className="sectionLeft">
          <SectionHeading className="sectionHeading" title={title} subtitle={subtitle} />
          <SolutionsList list={list} />
          {linkUrl && linkText && (
            <Link to={linkUrl} className="buttonLink link" arrow="right">
              <span>{linkText}</span> <ArrowRight className="arrow right" />
            </Link>
          )}
        </div>
        <div className="sectionRight">
          <LazyLoadImage src={image?.url} alt={image?.alternativeText || ""} effect="blur" />
        </div>
      </div>
    </div>
  );
};

export default BusinessSection;
